module.exports = __webpack_public_path__ + "static/media/diamond-excellence.6946aac2.svg";